import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/constants/queryKeys";
import { useCustomerScopedQuery } from "@/hooks/useCustomerScopedQuery";
import { services } from "@/services/registry";
export const useProducts = (enabled = true)=>{
    return useQuery({
        queryKey: queryKeys.products.all(),
        queryFn: ()=>services.productsService.getAllProducts(),
        enabled,
        staleTime: 10 * 60 * 1000
    });
};
export const useAvailableProducts = (enabled = true)=>{
    return useCustomerScopedQuery({
        queryKey: queryKeys.products.available(),
        queryFn: ({ customerId })=>services.productsService.getAvailableProducts(customerId),
        enabled,
        staleTime: 5 * 60 * 1000
    });
};
export const useProductWithUsagePlans = (productCode)=>{
    return useQuery({
        queryKey: queryKeys.products.byCode(productCode),
        queryFn: ()=>services.productsService.getProductWithUsagePlans(productCode),
        enabled: !!productCode,
        staleTime: 10 * 60 * 1000
    });
};
